import * as z from "zod";

export enum SendEmailAuthLinkError {
  InvalidEmail = "InvalidEmail",
  UnknownError = "UnknownError",
}
export const sendEmailAuthLink = {
  name: "sendEmailAuthLink" as const,
  input: z.object({
    email: z.string(),
    baseUrl: z.string(),
    nextUrl: z.string().optional(),
  }),
  output: z.object({}),
};
